<template lang="pug">
 #deleteTask
  .text-center
    b-icon(icon="x-circle" style="width: 80px; height: 80px; margin-bottom: 20px;" variant="danger")
    h2 ¿Estás Seguro?
    p Seguro que desea eliminar la tarea {{selectedTask.name}}
  .modal-footer
    b-button(@click="hideModal", variant="outline-muted") Cancelar
    b-button(@click="confirmDelete" variant="danger") Eliminar
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ["selectedTask", "hideModal", "makeToast"],
  data() {
    return{

    }
  },
  methods: {
    ...mapActions(['deleteTask']),
    async confirmDelete() {
      const response = await this.deleteTask(this.selectedTask.id);
      if (response.status === 200) {
        this.makeToast('success', response.data.message, "Tarea eliminada!");
        this.hideModal()
      } else {
        this.makeToast('danger', response.data, "Ocurrió un error!");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#deleteTask {
  .modal-footer {
    padding: 0;
  }  
}
</style>